import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import { FormattedMessage } from 'react-intl';

import { IWishlist } from '@/hooks/useWishlists';

import { WishlistCard } from './WishlistCard';

type TInspiringWishlistsProps = {
  wishlists: IWishlist[];
};

export const InspiringWishlists = ({ wishlists }: TInspiringWishlistsProps) => (
  <div className="pt-20">
    <Text variant={ETextStyleVariant.LargeBold} className="pb-6">
      <FormattedMessage defaultMessage="Inspiring wishlists" id="sNyxmC" />
    </Text>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
      {wishlists.map(item => (
        <WishlistCard key={item.id} wishlist={item} />
      ))}
    </div>
  </div>
);
